import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { ChatbotModal } from "./ChatbotModal";
import ducky from "../../assets/models/DuckyMesh.glb";

export function ChatbotModalContainer({ scene, onClose }) {
  const onSubmit = useCallback(
    ({ file, url }) => {
      console.log(file, url);
      // Array of allowed files
      if (file && file.length > 0) {
        const image = file[0];
        const fileType = image["type"];
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(fileType)) {
          // invalid file type code goes here.
          alert("File type invalid. It supports png, jpg and gif files.");
        } else {
          scene.emit("add_chatbot_media", image);
        }
        onClose();
      } else if (url) {
        scene.emit("add_chatbot_media", url);
        onClose();
      } else {
        alert("Please upload an image or paste a URL for your chatbot.");
      }
    },
    [scene, onClose]
  );

  return <ChatbotModal onSubmit={onSubmit} onClose={onClose} />;
}

ChatbotModalContainer.propTypes = {
  scene: PropTypes.object.isRequired,
  onClose: PropTypes.func
};
